<template>
  <MaterialCard
    color="green"
    full-width
  >
    <v-tabs>
      <v-tab ripple>
        情報
      </v-tab>
      <v-tab ripple>
        ユーザー
      </v-tab>
      <v-tab-item>
        <v-card flat>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    v-model="role.id"
                    label="id"
                    disabled
                  />
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-text-field
                    v-model="role.name"
                    class="purple-input"
                    label="ロール名"
                  />
                </v-flex>
                <v-flex
                  xs12
                >
                  <v-textarea
                    v-model="role.description"
                    label="説明"
                    class="purple-input"
                  />
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right
                >
                  <v-btn
                    class="mx-0"
                    color="success"
                    :to="{ path: '/authorities/role-edit', query: { id: role.id } }"
                  >
                    更新
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat>
          <v-form>
            <v-container py-0>
              <v-list
                v-for="item in role.users"
                :key="item.id"
              >
                <v-list-tile>
                  <v-list-tile-content>
                    {{ item.name }}
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      icon
                      ripple
                    >
                      <v-icon color="gray lighten-1">
                        mdi-trash
                      </v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
              <v-flex
                xs12
                text-xs-right
              >
                <v-btn
                  class="mx-0"
                  color="success"
                  :to="{ path: '/authorities/user-edit', query: { id: role.id } }"
                >
                  更新
                </v-btn>
              </v-flex>
            </v-container>
          </v-form>
        </v-card>
      </v-tab-item>
    </v-tabs>
  </MaterialCard>
</template>
<script>
export default {
  // eslint-disable-next-line
  props: {
    role: {
      type: Object,
      default: () => ({
      })
    }
  },
  data: () => ({
  })
}
</script>
